"use strict";
import Vue from "vue";
import vuex from "vuex";
import actions from './actions';
import UTILS from "@/utils/utils";
import DBUtils from "@/utils/dbUtils";

Vue.use(vuex);

const USER_DO = {
  email: "",
  nickname: "",
  orgName:'',
  usrId:'',
  emptyPw:false,
  SaaSBound: false,
  mobileBound: false,
  wxZjhyBound:false,
  emailBound: false,
  ycBound:false,
};

const state = {
  metaInfo: {
    title: "Home",
    keywords: "",
    description: ""
  },
  yunModel: UTILS.checkYunModel(), //在打开应用的时候就决定是不是yunModel，之后不再改变
  user: window.localStorage.user
    ? JSON.parse(window.localStorage.user)
    : USER_DO,
  token: window.localStorage.token,
  loadingDB: false
};

const mutations = {
  CAHNGE_META_INFO(state, metaInfo) {
    state.metaInfo = metaInfo;
  },
  updateUsrInfo: (state, payload) => {
    if (payload.usr) {
      state.user.usrId = payload.usr.usrId;
      state.user.nickname = payload.usr.nickname;
      state.user.email = payload.usr.email;
      state.user.orgName = payload.usr.orgName;
      state.user.emptyPw = payload.usr.emptyPw;
      state.user.SaaSBound = payload.usr.SaaSBound;
      state.user.mobileBound = payload.usr.mobileBound;
      state.user.ycBound = payload.usr.ycBound;
      state.user.wxZjhyBound = payload.usr.wxZjhyBound;
      state.user.emailBound = payload.usr.emailBound;
    }
    if (payload.token) {
      state.token = payload.token;
    }
  },
  clearInfo: (state, payload) => {
    state.user = USER_DO;
    state.token = "";
  },
  saveDB: state => {
    let user = state.user,
      token = state.token;
    window.localStorage.setItem("user", JSON.stringify(user));
    window.localStorage.setItem("token", token);
  },
  updateDBLoadingState: (state, payload) => {
    state.loadingDB = payload;
  }
};

const getters = {
  checkLogin: (state, getters, rootState) => {
    if (!state) {
      return false;
    }
    if (!!state.user && state.user.usrId > 0 && !!state.token) {
      return true;
    }
    return false;
  },
  getPortDB: async state => {
    return await DBUtils.getDBPorts();
  },
  getDBCitys: async state => {
    return await DBUtils.getDBCitys();
  },
  getDBAirlines: async state => {
    return await DBUtils.getDBAirlines();
  },

  getCountryCode: async state => {
    return await DBUtils.getCountryCode();
  }
};

const modules = {};

export default new vuex.Store({
  state,
  mutations,
  modules,
  actions,
  getters
});
